import { IncrementalEventData } from './incremental-event-data';
import { SerializedNodeWithId } from './node';

/** 事件类型 */
export enum WebEventType {
	DomContentLoaded,
	Loaded,
	FullSnapshot,
	IncrementalSnapshot,
	Meta,
	Custom,
}

/** 自定义事件 */
export type CustomEvent = {
	type: WebEventType.Custom;
	data: {
		tag: string;
		payload: any;
	};
};

/** Meta事件 */
export type MetaEvent = {
	type: WebEventType.Meta;
	data: {
		href: string;
		width: number;
		height: number;
	};
};

/** DOM内容加载完毕事件 */
export type DomContentLoadedEvent = {
	type: WebEventType.DomContentLoaded;
	data: {};
};

/** 资源加载完毕事件 */
export type LoadedEvent = {
	type: WebEventType.Loaded;
	data: {};
};

/** 全量抓取事件 */
export type FullSnapshotEvent = {
	type: WebEventType.FullSnapshot;
	data: {
		node: SerializedNodeWithId;
		initialOffset: {
			top: number;
			left: number;
		};
		iconFonts?: Array<string>;
	};
};

/** 增量抓取事件 */
export type IncrementalSnapshotEvent = {
	type: WebEventType.IncrementalSnapshot;
	data: IncrementalEventData;
};

/** 所有事件 */
export type WebEvent =
	| DomContentLoadedEvent
	| LoadedEvent
	| FullSnapshotEvent
	| IncrementalSnapshotEvent
	| MetaEvent
	| CustomEvent;

/** 增加事件的时间 */
export type WebEventWithTime = WebEvent & {
	originalTimestamp?: number;//原始时间戳，重新计算timestamp后无法使用，所以新增该字段用于视频播放时展示
	timestamp: number;
	delay?: number;
};
